module.exports = __webpack_public_path__ + "img/05010007.5d2da227.jpg";